import moment from 'moment'

// query searching for requests of the selected update using update_date_id
export const getAcceptedRequestsQueryByUpdateDateId = updateDateId => ({
    should: [
        {
            bool: {
                must: [
                    {
                        term: {
                            'status' : 'accepted' 
                        }
                    },
                    {
                        term: {
                            "sender.update_date_id" : updateDateId 
                        }
                    }

                ]
            }, 
        },
        {
            bool: {
                must: [
                    {
                        term: {
                            'status' : 'accepted' 
                        }
                    },
                    {
                        term: {
                            "receiver.update_date_id" : updateDateId 
                        }
                    }

                ]
            }
        }
    ]
})


// query searching for accurate requests of the selected update using other params than update_date_id
export const getAcceptedRequestsQueryByMultipleParams = (campaignId, partnerCampaigns, updateDate) => ({
    should: [
        {
            bool: {
                must: [
                    {
                        term: {
                            'status' : 'accepted' 
                        }
                    },
                    {
                        term: {
                            "sender.campaign" : campaignId 
                        }
                    },
                    {
                        terms: {
                            "receiver.campaign" : partnerCampaigns 
                        }
                    },
                    {
                        range: {
                            'sender.update_date._seconds': {
                                gte: moment.utc(updateDate).subtract(1, 'days').valueOf() / 1000,
                                lte: moment.utc(updateDate).add(1, 'days').valueOf() / 1000,
                            }
                        }
                    }
                ]
            }, 
        },
        {
            bool: {
                must: [
                    {
                        term: {
                            'status' : 'accepted' 
                        }
                    },
                    {
                        term: {
                            "receiver.campaign" : campaignId 
                        }
                    },
                    {
                        terms: {
                            "sender.campaign" : partnerCampaigns 
                        }
                    },
                    {
                        range: {
                            'receiver.update_date._seconds': {
                                gte: moment.utc(updateDate).subtract(1, 'days').valueOf() / 1000,
                                lte: moment.utc(updateDate).add(1, 'days').valueOf() / 1000,
                            }
                        }
                    }
                ]
            }
        }
    ]
})